import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import PropTypes from 'prop-types'
import React from 'react'

import SimpleIcon from '../../generic/components/SimpleIcon'

const MainMenuCloseButton = ({ toggleMainMenu }) => (
  <button
    type='button'
    className='close'
    onClick={toggleMainMenu}
    aria-label='Schließen'
  >
    <span aria-hidden='true'><SimpleIcon icon={faTimes} /></span>
  </button>
)

MainMenuCloseButton.propTypes = {
  toggleMainMenu: PropTypes.func
}

export default MainMenuCloseButton
